import { useCallback } from 'react';

import { c } from 'ttag';

import { getApiErrorMessage } from '@proton/shared/lib/api/helpers/apiErrorHelper';
import { traceError } from '@proton/shared/lib/helpers/sentry';

import useNotifications from './useNotifications';

const ignoreErrors = ['InactiveSession', 'AppVersionBadError', 'AbortError'];

const useErrorHandler = () => {
    const { createNotification } = useNotifications();

    return useCallback((error: any, { notify = true, trace = true }: { notify?: boolean; trace?: boolean } = {}) => {
        if (!error) {
            return;
        }

        const apiErrorMessage = getApiErrorMessage(error);
        const errorMessage = error.message || c('Error').t`Unknown error`;

        // Bad app version and unreachable errors are handled in a top banner
        const shouldNotify = notify && !error.cancel && !ignoreErrors.includes(error.name);
        if (shouldNotify) {
            createNotification({ type: 'error', text: apiErrorMessage || errorMessage });
        }

        const shouldTrace = trace && error.trace !== false && !apiErrorMessage;
        if (shouldTrace) {
            traceError(error);
        }
    }, []);
};

export default useErrorHandler;
